export default __webpack_public_path__ + "static/media/ms_events.826f75c6.bmp";